import { getFeature } from "../../utils/features";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import useMultiDepthExperimentThreshold from "./useMultiDepthExperimentThreshold";

const isRatingDataValid = (ratings, reviewNumberThreshold) =>
  ratings?.averageOverallStarRating &&
  parseFloat(ratings?.totalReviewCount) >= reviewNumberThreshold;

const useRatingsFeatureRequirements = (ratings, isInStock) => {
  const { features: serverFeatures } = useRuntimeConstants();
  const { areFeaturesReady } = useFeaturesReady();
  const { threshold, showReviews } = useMultiDepthExperimentThreshold();

  const shouldEnableRatings = ({ ratings, threshold, isInStock }) =>
    isRatingDataValid(ratings, threshold) && isInStock === true && showReviews;

  const isFeatureSetReadyAndEnabled = ({ areFeaturesReady }) =>
    areFeaturesReady &&
    getFeature("pdp-ratings-and-reviews").isEnabled() &&
    serverFeatures.ratings;

  return (
    isFeatureSetReadyAndEnabled({ areFeaturesReady }) &&
    shouldEnableRatings({ ratings, threshold, isInStock })
  );
};

export default useRatingsFeatureRequirements;
